import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";
import {StripeServiceProvider} from "../../providers/stripe-service/stripe-service";

/**
 * Generated class for the PaymentErrorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-payment-error',
  templateUrl: 'payment-error.html',
})
export class PaymentErrorPage {

  paymentIntentId: string;
  public shopType: 'coffe' | 'barber';
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public bookingsService: BookingServiceProvider,
    public stripeService: StripeServiceProvider
  ) {
    this.paymentIntentId = navParams.get('paymentIntentId');
    this.shopType = navParams.get('shopType');
    this.stripeService.cancelPaymentIntent(this.paymentIntentId);
  }

  gotoMyBookings(){
    this.bookingsService.gotoMyBookings(this.navCtrl);
  }

}



// WEBPACK FOOTER //
// ./src/pages/payment-error/payment-error.ts